Bingo.PropertySelector = {};

Bingo.PropertySelector.changeFormHeading = function (radio, heading, label) {
    $(radio).click(function () {
        const radioLabel = $(this).text();
        if ($(heading).length !== 0) {
            $(heading).text(`${label} ${radioLabel}`);
        }
    });
};
